module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "partners"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "aligncenter",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "partners-swiper-container swiper-container wide-slider"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.slides), function(slide, index) {
    return _c('div', {
      key: index,
      staticClass: "swiper-slide"
    }, [_c('a', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "text"
    }, [(slide.image.url) ? _c('img', {
      attrs: {
        "src": slide.image.url,
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "desc",
      domProps: {
        "innerHTML": _vm._s(slide.description)
      }
    })])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "partners-swiper-prev wide-slider-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "partners-swiper-next wide-slider-next"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2277ec2e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PartnersSlider.vue
// module id = 319
// module chunks = 0